<template>
  <div class="page" @touchmove.prevent>
    <div class="bg-window"></div>
    <div class="main">
      <div class="hints">
        <div class="hint">↓长按识别下方二维码</div>
        <div class="hint">进入公众号<span class="account">{{account_name}}</span>即可报名</div>
        <!-- <div class="hint">即可报名</div> -->
      </div>
      <img v-if="url" class="qrcode" :src="url">
      <div class="monitor hints">
        <div class="hint"><span>•</span><span class="referal">{{referal}}</span></div>
      </div>
    </div>

  </div>
</template>

<script>
import { Dialog } from 'vant'

export default{
  components: {
    [Dialog.name]: Dialog
  },
  data(){
    return {
      url: "",
      referal: "",
      account_name: ""
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    getUrl(){
      this.referal = this.$route.params.referal.toLowerCase()
      if(this.referal.includes('lang3dayscp')){
        this.account_name = '【浪漫员3天CP】'
      }else{
        this.account_name = '【浪漫员Club】'
      }
      this.url = `https://static.langmanyuan.com/cponline-entry-${this.referal}.jpeg`
    }
  },
  mounted(){
    this.getUrl()
  }
}
</script>

<style scoped>
.page{min-height:100vh;}
.bg-window{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  /* background-image: url("https://static.huiyiji520.com/cponline-1659166921.jpg"); */
  /* background-image: url("https://static.huiyiji520.com/bg-1661137902.png"); */
  /* background-image: url("https://static.huiyiji520.com/cppic-1661150074.png"); */
  background-size:100% 100%;
  background-repeat:no-repeat;
  /* opacity:0.1; */
  z-index:-1;
}
.main{text-align:center;color:#333;font-weight:bold;padding-top:200px;}
/* .main .title{margin-top:200px;margin-bottom:113px;font-size:70px;color:#eb8e80;font-weight:bold;font-family:'NotoSerifSCBlack';}
.main .declaration{font-size:40px;line-height:80px;color:#737373;margin-bottom:113px;} */
.main .qrcode{width:340px;display:block;margin:0 auto;margin-top:20px;margin-bottom:20px;}
.main .hints{font-size:32px;}
.main .hints .hint{margin-bottom:15px;}

.main .monitor{margin-top:200px;text-align:left;}
.main .monitor .referal{color:#fff;}
</style>
